// @flow @format
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import makeRoutes from './routes';
import createSagaMiddleware from 'redux-saga';
import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import reducers, {type StoreState} from './reducers';
import sagas from './sagas';
import './index.css';

// inital state loading
const preloadedState: StoreState = {};
const storedSession = window.localStorage.getItem('cloner_session');
const params = new URLSearchParams(window.location.search);

if (
	params.has('token') &&
	params.has('group') &&
	params.has('user') &&
	params.has('server')
) {
	let server = params.get('server');

	if (server.charAt(server.length - 1) === '/') {
		server = server.slice(0, server.length - 1);
	}

	const session = {
		isLoggedIn: true,
		group: parseInt(params.get('group'), 10),
		token: params.get('token'),
		user: params.get('user'),
		server: server,
	};

	window.localStorage.setItem('cloner_session', JSON.stringify(session));
	preloadedState.session = session;
} else if (storedSession) {
	try {
		preloadedState.session = JSON.parse(storedSession);
	} catch (e) {
		console.error(`Warning: error parsing stored session, ${e}`);
	}
}

// redux middlewares
const sagaMiddleware = createSagaMiddleware();
let reduxMiddleWare = applyMiddleware(sagaMiddleware);

if (process.env.NODE_ENV === 'production') {
	window.addEventListener('load', () =>
		// $FlowFixMe: how can we extend a built-in declaration?
		navigator.serviceWorker.register('/service-worker.js')
	);
} else {
	// TODO(ja): keep removing avoidable renders.
	// const {whyDidYouUpdate} = require('why-did-you-update');
	// whyDidYouUpdate(React);
	reduxMiddleWare = composeWithDevTools(reduxMiddleWare);
}

const store = createStore(reducers, preloadedState, reduxMiddleWare);
const routes = makeRoutes(store);

sagaMiddleware.run(sagas);

ReactDOM.render(
	<App routes={routes} store={store} />,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js